module.exports = __webpack_public_path__ + "static/media/55698505_586604541826166_5599898215882162176_o.e1018bd4.jpg";